import { useEffect, useMemo, useRef } from "react";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { LoadDataCart, checkLogin } from "../../redux/Login/Login";
import { settings, clearRedirect401Flag } from "../../utils/config";
import { cacheInvalidatePrefix } from "../../utils/cache";

/**
 * /loadata?user_token=...&user_idw=...
 * 10/10 UX:
 * - Xử lý SSO nhanh
 * - Vào dashboard ngay (KHÔNG BLOCK)
 * - Load dữ liệu nền (background)
 */
export default function LoadDatabase() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const ranRef = useRef(false);

  const qs = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const userToken = qs.get("user_token");
  const userIdwParam = qs.get("user_idw");

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      try {
        // luôn đọc cookie tại thời điểm chạy
        let currentIdw = settings.getCookie("user_idw");

        // 1) Nếu có SSO token -> đổi token
        if (userToken) {
          const loginResult = await dispatch(checkLogin({ user_token: userToken }));
          const data = loginResult?.payload?.data;

          if (data?.status !== 200) {
            message.error("Lỗi xác thực SSO. Vui lòng đăng nhập lại.");
            navigate("/login", { replace: true });
            return;
          }

          // user_token: backend Set-Cookie HttpOnly; không set từ FE
          if (data?.access_token) clearRedirect401Flag();

          // Lưu idw ưu tiên API trả về
          const newIdw = data?.web_id || userIdwParam;
          if (newIdw) {
            // Invalidate product cache when switching shop/idw
            if (currentIdw && currentIdw !== newIdw) {
              cacheInvalidatePrefix("products_");
            }
            settings.setCookie("user_idw", newIdw, 365);
            currentIdw = newIdw;
          }
        }

        // 2) Không có idw -> về login
        if (!currentIdw) {
          message.error("Không tìm thấy thông tin cửa hàng. Vui lòng đăng nhập lại.");
          navigate("/login", { replace: true });
          return;
        }

        // 3) Vào dashboard ngay (UX nhanh)
        navigate("/", { replace: true });
        message.success("Đăng nhập thành công");

        // 4) Load nền (không await)
        //dispatch(LoadDataProduct({ idw: currentIdw }));
        dispatch(LoadDataCart({ idw: currentIdw }));
      } catch (e) {
        message.error("Có lỗi khi xử lý đăng nhập. Vui lòng thử lại.");
        navigate("/login", { replace: true });
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // Trang này chỉ là handler redirect, không cần UI
  return null;
}
